import { Navbar, Nav } from 'rsuite';
import ls from 'localstorage-slim';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

import { refreshToken, logout, updateUserLastLogin } from '../helpers';

function Header() {
  const subDomain = ls.get('subDomain');

  let navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const [authUser, setAuthUser] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  const handleSwitchTaxpayer = () => {
    ls.remove('ETAToken');
    navigate('taxpayer');
  };

  const handleLogout = async () => {
    await logout();
  };

  const handleChangeLanguage = () => {
    i18n.language === 'ar' ? i18n.changeLanguage('en') : i18n.changeLanguage('ar');
  };

  useEffect(() => {
    async function fetchData() {
      try {
        if (!ls.get('access')) {
          await refreshToken();
          await updateUserLastLogin();
        }

        let response = await axios.get(
          `${subDomain}${process.env.REACT_APP_DJANGO_BASEURL}/auth/token`,
          {
            params: { access: ls.get('access'), taxpayer: ls.get('taxpayer_id') },
          }
        );

        setAuthUser(response.data);
        setIsLoading(false);
      } catch (error) {
        if (error.response) {
          // Request made but the server responded with an error
          console.log(error.response.data);

          console.log(error.response.data);
        } else if (error.request) {
          // Request made but no response is received from the server.
          console.log(error.request);
        } else {
          // Error occured while setting up the request
          console.log('Error', error.message);
        }
      }
    }

    fetchData();
  }, []);

  return (
    <>
      <div className='container-fluid'>
        <Navbar>
          <Nav
            pullRight={i18n.language === 'en'}
            className='d-flex d-flex-column justify-content-center'>
            {!isLoading && (
              <Nav.Menu
                placement={`${i18n.language === 'en' ? 'bottomEnd' : 'bottomStart'}`}
                noCaret
                title={
                  <div className='d-flex-column'>
                    <div className='row mx-0 text-center fw-bold'>
                      <span>{`${authUser.taxpayer}`}</span>
                    </div>
                    <div className='row mx-0 text-center text-muted'>
                      <span>{`${authUser.email}`}</span>
                    </div>
                  </div>
                }>
                {/* <Nav.Item disabled={true}>Change Password</Nav.Item> */}
                <Nav.Item onClick={handleSwitchTaxpayer}>{t('layout.header.switch')}</Nav.Item>
                <Nav.Item onClick={handleLogout}>{t('layout.header.logout')}</Nav.Item>
              </Nav.Menu>
            )}
          </Nav>
          <div
            className={`${
              i18n.language === 'en' ? 'justify-content-end' : 'justify-content-start'
            } d-flex my-2 `}>
            <div
              className={`d-inline-block landing-page__button text-center py-2`}
              onClick={handleChangeLanguage}
              role={'button'}>
              <span className='text-capitalize'>{i18n.language === 'ar' ? 'en' : 'ar'}</span>
            </div>
          </div>
        </Navbar>
      </div>
    </>
  );
}

export default Header;
